import { getVar } from "config";

export const DAILY_API_URL = getVar("REACT_APP_DAILY_API_URL");
export const JOIN_MEETING_CACHE_KEY = "JOIN_MEETING";
